const IconProfessional = () => (
  <svg
    width="35px"
    height="29px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.703 3.493c-3.948 0-7.407 1.92-9.436 4.809a1.5 1.5 0 1 1-2.455-1.725C8.4 2.895 12.77.493 17.702.493c7.866 0 14.35 6.132 14.35 13.825 0 2.579-.892 4.84-1.738 6.415a16.847 16.847 0 0 1-1.312 2.068l.995 7.725-7.001-3.384c-.137.049-.29.102-.454.158-.569.194-1.344.442-1.935.56a1.5 1.5 0 1 1-.583-2.944c.374-.074.98-.261 1.55-.456a35.457 35.457 0 0 0 .902-.32l.054-.02.013-.006.607-.23 3.164 1.53-.454-3.527.442-.506.002-.001.016-.02a10.154 10.154 0 0 0 .385-.5c.262-.36.614-.89.966-1.546.713-1.329 1.38-3.091 1.38-4.996 0-5.92-5.021-10.825-11.348-10.825Z"
      fill="#fff"
    />
    <path
      d="M16.983 5.033c.62 0 1.125.504 1.125 1.125v8.31h4.335a1.125 1.125 0 0 1 0 2.25h-5.46a1.125 1.125 0 0 1-1.125-1.124V6.158c0-.621.503-1.125 1.125-1.125Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.935 10.011a2.666 2.666 0 0 0-3.053 2.406l-.072.83A16.175 16.175 0 0 0 13.36 30.423a2.582 2.582 0 0 0 3.075-1.9l.521-2.109a3.389 3.389 0 0 0-1.95-3.925l-2.559-1.1-2.08 1.239a9.05 9.05 0 0 1-3.013-4.305l-.014-.043 1.696-1.384-.332-3.655a3.256 3.256 0 0 0-2.758-2.926l-2.012-.303Zm-.513 2.626a.116.116 0 0 1 .133-.104l2.012.303c.322.048.569.31.598.634l.21 2.306-1.205.983a1.499 1.499 0 0 0-.477 1.628l.238.727a11.598 11.598 0 0 0 4.567 6.03 1.46 1.46 0 0 0 1.56.04l1.578-.94 1.363.586a.84.84 0 0 1 .483.972l-.521 2.11-.005.01a.036.036 0 0 1-.01.009.033.033 0 0 1-.011.005l-.012-.001A13.625 13.625 0 0 1 3.35 13.468l.072-.83Z"
      fill="#fff"
    />
  </svg>
);

export default IconProfessional;
